const ID_TOKEN_KEY = "id_token";
const USER_EMAIL = "user_email";

export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const getUserEmail = () => {
  return window.localStorage.getItem(USER_EMAIL);
};

export const saveToken = token => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const saveUserEmail = email => {
  window.localStorage.setItem(USER_EMAIL, email);
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken, getUserEmail, saveUserEmail };
